import { defineMessages } from 'react-intl';

export default defineMessages({
    nextDescription: {
        id: 'ml.cancellation.common.views.cancel-policy.We confirm policy cancellation next',
        defaultMessage: 'We\'ll <strong>confirm policy cancellation</strong> next'
    },
    effectiveDate: {
        id: 'ml.cancellation.common.views.cancel-policy.Effective Date',
        defaultMessage: 'Effective Date'
    },
    initiator: {
        id: 'ml.cancellation.common.views.cancel-policy.Initiator',
        defaultMessage: 'Who is initiating this change?'
    },
    cancelReason: {
        id: 'ml.cancellation.common.views.cancel-policy.Reason',
        defaultMessage: 'Reason for Cancelling Policy'
    },
    carrier: {
        id: 'ml.cancellation.common.views.cancel-policy.Replacement Carrier',
        defaultMessage: 'Replacement Carrier'
    },
    create: {
        id: 'ml.cancellation.common.config.Creating cancellation',
        defaultMessage: 'Creating cancellation'
    },
    createErrorTitle: {
        id: 'ml.cancellation.common.config.Unable to create cancellation',
        defaultMessage: 'Unable to create cancellation'
    },
    createErrorMsg: {
        id: 'ml.cancellation.common.config.An error occurred while attempting to create the cancellation',
        defaultMessage: 'An error occurred while attempting to create the cancellation'
    },
    insuredVerballyRequested: {
        id: 'ml.cancellation.common.config.I confirm that named insured verbally requested the cancellation',
        defaultMessage: 'I confirm that named insured verbally requested the cancellation.'
    },
    insuredWrittenRequested: {
        id: 'ml.cancellation.common.config.The named insured requested the cancellation via written statement (email or other). Documentation is retained by my agency in accordance with document retention guidelines',
        defaultMessage: 'The named insured requested the cancellation via written statement (email or other). Documentation is retained by my agency in accordance with document retention guidelines.'
    },
    errorTitle: {
        id: 'ml.cancellation.common.config.errorHeader',
        defaultMessage: '<strong>Heads up!</strong>'
    },
    errorMessage1: {
        id: 'ml.cancellation.common.config.errorMessage1',
        defaultMessage: 'The cancellation request for this policy must be finalized by the <strong>Customer Retention Team (CRT)</strong>.'
    },
    errorMessage2: {
        id: 'ml.cancellation.common.config.errorMessage2',
        defaultMessage: 'Please ask the customer to contact <strong>844-592-0472</strong>.'
    },
    errorMessage3: {
        id: 'ml.cancellation.common.config.errorMessage3',
        defaultMessage: 'If the customer does not wish to speak with CRT, please contact <strong>Service Ops at 800-422-4272</strong> to finalize their cancellation request.'
    },
    replacementLabelFullPolicy: {
        id: 'ml.cancellation.common.config.replacementLabelFullPolicy',
        defaultMessage: 'Replacement Policy Number (Full Policy #)'
    },
    replacementLabelLastFourDigits: {
        id: 'ml.cancellation.common.config.replacementLabelLastFourDigits',
        defaultMessage: 'Replacement Policy Number (Last 4 digits)'
    },
    missingField: {
        id: 'ml.cancellation.common.config.missingField',
        defaultMessage: 'Please enter the missing information. This is a required field.'
    },
    onlyAlphaNumbericWithMax: {
        id: 'ml.cancellation.common.config.onlyAlphaNumbericWithMax',
        defaultMessage: 'Only Alphanumeric with maximum of {maxDigit} digits allowed.'
    },
    onlyFourDigits: {
        id: 'ml.cancellation.common.config.onlyFourDigits',
        defaultMessage: 'Only 4 digits allowed.'
    },
    max20Digits: {
        id: 'ml.cancellation.common.config.max20Digits',
        defaultMessage: 'Enter valid Replacement Policy Number maximum of 20 alphanumeric.'
    },
    enterReplacementCarrier: {
        id: 'ml.cancellation.common.config.replacementCarrier',
        defaultMessage: 'Please enter the valid Replacement carrier.'
    },
    enterReplacementPolicyNumber: {
        id: 'ml.cancellation.common.config.replacementPolicyNumber',
        defaultMessage: 'Please enter the valid Replacement policy number.'
    },
    wnsCancellationMsg1: {
        id: 'ml.cancellation.common.config.wnsCancellationMsg1',
        defaultMessage: '<strong>ALERT:</strong>'
    },
    wnsCancellationMsg2: {
        id: 'ml.cancellation.common.config.wnsCancellationMsg2',
        defaultMessage: 'Cancellation required by Customer Retention Team (CRT).'
    },
    wnsCancellationMsg3: {
        id: 'ml.cancellation.common.config.wnsCancellationMsg3',
        defaultMessage: 'Please transfer to CRT. Share 844-592-0472 only if the customer requests to call directly.'
    }
});